import { colors } from 'ui/theme';
import { fontConfig, shapeNames } from '../../constants';

export const SEND_ACTION_ACCENT_COLOR = colors.cyan100;
export const SEND_ACTION_BACKGROUND_ACCENT_COLOR = colors.cyan100;
export const SEND_ACTION_BORDER_ACCENT_COLOR = colors.cyan100;
export const SEND_ACTION_DEFAULT_TITLE = 'Send actions';

export const sendActionOptions = {
  defaultTitle: SEND_ACTION_DEFAULT_TITLE,
  accentColor: SEND_ACTION_ACCENT_COLOR,
  activeBorderColor: SEND_ACTION_BORDER_ACCENT_COLOR,
  accentColorBackground: SEND_ACTION_BACKGROUND_ACCENT_COLOR,
  [shapeNames.footerText]: {
    ...fontConfig.fs14,
    ...fontConfig.default,
    fill: colors.textSecondary,
  },
  footerStartY: 90,
};
